<template>
  <div>
    <div class="wip">
        <p class="wip-text">
          Work in Progress </p>
    </div>
    <d-alert class="alert-royal-blue" style="text-align:center;" show>
      <i class="fa fa-info mx-2"></i>
      <strong>Have a Question?</strong> We're here to help.<d-button class="ml-3 btn-white">Get Help</d-button></d-alert>

    <d-container fluid class="main-content-container px-4">

      <!-- Page Header -->
      <d-row no-gutters class="page-header py-2 pb-4 mb-3 border-bottom">
        <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Your Account</span>
          <h3 class="page-title">Billing</h3>
        </d-col>
      </d-row>

      <!-- Colors -->
      <d-row>
        <d-col lg="12" class="mb-4">


            <div class="flex-container">
              <div class="flex-item">
                <ul class="package">
                  <li class="header">Current Plan: Starter</li>
                  <li class="gray">$95/month</li>

                  <li class="gray">
                    <button
                      style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
                      id="checkout-button-plan_FdTFpq63owgaiz"
                      role="link"
                      @click="stripe()"
                    >
                      Checkout
                    </button>

                    <div id="error-message"></div></li>
                </ul>
              </div>
              <div class="flex-item">
                <ul class="package">
                  <li class="header highlight">Growth</li>
                  <li class="gray">$295/month</li>

                  <li class="gray">
                    <button
                      style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
                      id="checkout-button-plan_FdTFpq63owgaiz"
                      role="link"
                      @click="stripe()"
                    >
                      Upgrade
                    </button>

                    <div id="error-message"></div> </li>
                </ul>
              </div>
              <div class="flex-item">
               <ul class="package">
                  <li class="header">Scale</li>
                  <li class="gray">$ 495/month</li>

                  <li class="gray">
                    <button
                      style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
                      id="checkout-button-plan_FdTFpq63owgaiz"
                      role="link"
                      @click="stripe()"
                    >
                      Upgrade
                    </button>

                    <div id="error-message"></div></li>
                </ul>
              </div>
            </div>








              </d-list-group-item>
            </d-list-group>
          </d-card>
        </d-col>
      </d-row>

    </d-container>
  </div>
</template>

<script>

import Quill from 'quill';

export default {
  methods: {

  }

}

</script>

<style>
.add-new-post__editor {
  height:200px !important;
}

.explainer {
  margin-top: 0px;
  font-size: 80%;
  color: grey;
  margin-bottom:5px;
}
.see-example {
  display:inline-block;
  text-decoration: underline !important;
  text-decoration-style: dashed !important;
  color: #f2557a !important;
}

pre {
  margin-bottom: .75rem;
  font-size: 0.75rem;
  color: #414770;
  line-height: 1.375rem;
  background: #fafcff;
  border-radius: 5px;
}

.color-large {
  width: 100px;
  border: none;
  height: 70px;
  outline: none;
  -webkit-appearance: none;
  padding:0px;
}

.form-divider {
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  border-bottom: 1px solid #e1e5eb;
}

* {
  box-sizing: border-box;
  font-family: -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen-Sans,
    Ubuntu,
    Cantarell,
    "Helvetica Neue",
    sans-serif;
  margin: 0;
  padding: 0;
}

.flex-container {
  display: flex;
  padding: 1em;
}

.flex-item {
  flex: 1;
  width: 0;
}

.flex-item:not(:last-child) {
  margin-right: 1em;
}

.package {
  border: 1px solid #eee;
  list-style-type: none;
  margin: 0;
  padding: 0;
  transition: 0.25s;
}

.package:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
  transform: scale(1.025);
}

.package .header {
  background-color: #333;
  color: #fff;
  font-size: 1.5em;
}

.package .highlight {
  background-color: #29b6f6;
}

.package li {
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 1.2em;
  text-align: center;
}

.package .gray {
  background-color: #eee;
  font-size: 1.25em;
}

button {
  background-color: #29b6f6;
  border: none;
  border-radius: .15em;
  color: #fff;
  cursor: pointer;
  padding: .75em 1.5em;
  font-size: 1em;
}

@media only screen and (max-width: 700px) {
  button {
    padding: .75em;
  }
}

@media only screen and (max-width: 600px) {
  .flex-container {
    flex-wrap: wrap;
  }

  .flex-item {
    flex: 0 0 100%;
    margin-bottom: 1em;
    width: 100%;
  }

  .package:hover {
    box-shadow: none;
    transform: none;
  }

  button {
    padding: .75em 1.5em;
  }
}
.wip {
  margin-right: 0px;
  /* right: 13px; */
  /* left: 14px; */
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: #f2f7fdad;
  z-index: 100;
}
</style>
